import { Wordmark } from './WaveMark';
import { NAV_LINKS, CONTACT_INFO } from '../lib/site';

const FooterBrand = () => (
  <div className="lg:col-span-5">
    <Wordmark />
    <p className="mt-8 max-w-sm font-body text-[15px] text-[#94A3B8] leading-relaxed font-light">
      An independent midstream and trading company connecting global energy markets with speed, integrity and operational excellence.
    </p>
    <div className="mt-8 h-px w-16 bg-[#00E5FF]/40" />
  </div>
);

const FooterNav = () => (
  <div className="lg:col-span-3 lg:col-start-7">
    <h4 className="font-body text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] mb-7 font-semibold">Navigate</h4>
    <ul className="space-y-4">
      {NAV_LINKS.map((l) => (
        <li key={l.href}>
          <a
            href={l.href}
            className="font-body text-sm text-[#94A3B8] hover:text-white transition-colors duration-300 tracking-wide"
            data-testid={`footer-link-${l.href.replace('#', '')}`}
          >
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

const FooterContact = () => (
  <div className="lg:col-span-3">
    <h4 className="font-body text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] mb-7 font-semibold">Contact</h4>
    <a
      href={`mailto:${CONTACT_INFO.email}`}
      className="font-body text-sm text-[#94A3B8] hover:text-white transition-colors duration-300 tracking-wide block"
      data-testid="footer-email"
    >
      {CONTACT_INFO.email}
    </a>
    <p className="mt-4 font-body text-sm text-[#94A3B8] tracking-wide whitespace-pre-line">{CONTACT_INFO.location}</p>
  </div>
);

const FooterBottomBar = () => (
  <div className="border-t border-white/5">
    <div className="mx-auto max-w-7xl px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
      <p className="font-body text-xs text-[#94A3B8] tracking-wide">
        &copy; {new Date().getFullYear()} Voyager Energy Partners. All rights reserved.
      </p>
      <p className="font-body text-xs text-[#94A3B8] tracking-wide uppercase">
        Moving molecules. Connecting markets.
      </p>
    </div>
  </div>
);

export default function Footer() {
  return (
    <footer className="bg-[#050B14] border-t border-white/8" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 md:px-12 pt-20 pb-12 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <FooterBrand />
        <FooterNav />
        <FooterContact />
      </div>
      <FooterBottomBar />
    </footer>
  );
}
